import { lazy } from "react";

const routes = [
  {
    path: "/settings/entities",
    element: lazy(() => import("../../pages/Settings/Entities")),
  },
];

export default routes;
